"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _RequestAddons = _interopRequireDefault(require("../components/RequestAddons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function RequestAddons(props) {
  return (/*#__PURE__*/_react.default.createElement(_commonReact.AddonsConsumer, null, function (_ref) {
      var _ref$actions = _ref.actions,
          getAddonsCost = _ref$actions.getAddonsCost,
          mergeAddon = _ref$actions.mergeAddon;
      return (/*#__PURE__*/_react.default.createElement(_RequestAddons.default, _extends({
          getAddonsCost: getAddonsCost,
          mergeAddon: mergeAddon
        }, props))
      );
    })
  );
}

var _default = RequestAddons;
exports.default = _default;